import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  CheckpointFilterDto,
  CheckpointItemDto,
  CheckpointService, SortDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { catalogReadOnlyBanner, catalogTenantId, isCatalogReadOnly, isInternalTenant } from '@/utils/admin-utils';
import OrderEnum = SortDto.OrderEnum;
import { computed } from '@angular/core';

@Component({
  standalone: false,
  selector: 'wr-checkpoint-overview-page',
  templateUrl: './checkpoint-overview-page.component.html',
  styleUrls: ['./checkpoint-overview-page.component.scss'],
})

export class CheckpointOverviewPageComponent implements AfterViewInit{
  private readonly internalTenant = isInternalTenant();
  readonly catalogReadOnly = isCatalogReadOnly();
  readonly catalogBanner = catalogReadOnlyBanner();
  readonly isAdmin = computed(() => this.internalTenant() && !this.catalogReadOnly());
  form!: FormGroup;

  readonly tenantId = catalogTenantId();

  readonly loadCheckpoints = (filter: CheckpointFilterDto) => this.checkpointService.findAll(this.createFilter(filter));
  readonly getCount = (filter: CheckpointFilterDto) => this.checkpointService.getCount(this.createFilter(filter));

  createFilter(filter: CheckpointFilterDto): CheckpointFilterDto {
    if(!filter.sort) {
      filter.sort = {
        sort: 'fullNumber',
        order: OrderEnum.Asc,
      };
    }
    return {
      ...filter,
      tenantId: this.tenantId(),
    };
  }

  constructor(
    private readonly checkpointService: CheckpointService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
      checkpointGroupId: this.formBuilder.control(''),
      deprecated: this.formBuilder.control(false),
    });
  }

  getCheckpointNumber(checkpoint: CheckpointItemDto): string {
    return checkpoint.checkpointGroupNumber + '.' + checkpoint.number;
  }

  readonly exportCheckpointNumber = (checkpoint: CheckpointItemDto): string =>
    this.getCheckpointNumber(checkpoint);

  getCheckpointGroupName(checkpoint: CheckpointItemDto): string {
    return checkpoint.checkpointGroupName.substring(0, 30) + '';
  }

  navigateToCheckpoint(checkpoint: CheckpointItemDto): void {
    this.router.navigate(['checkpoint', checkpoint.id]);
  }

  add(): void {
    this.router.navigate(['checkpoint', 'new']);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.form.patchValue(this.form.value);
    });
  }
}
